import { Primitive } from "src/types/primitive";
import { useController } from "react-hook-form";
import { UseControllerProps } from "react-hook-form";
import { LazySelectField, LazySelectFieldProps } from "../../inputFields/LazySelectField";
import { ConditionalNullable } from "src/components/common/inputFields/types.ts";

export interface FormLazySelectFieldProps<
	TFieldValues extends object,
	Option,
	Key extends Primitive,
	DisableClearable extends boolean | undefined,
> extends Omit<
	LazySelectFieldProps<Option, Key, DisableClearable>,
	"value"
> {
	control: UseControllerProps<TFieldValues>["control"];
	name: UseControllerProps<TFieldValues>["name"];
	rules?: UseControllerProps<TFieldValues>["rules"];
}

export const FormLazySelectField = <
	TFieldValues extends object,
	Option,
	Key extends Primitive,
	DisableClearable extends boolean | undefined,
>({
	  control,
	  name,
	  rules,
	  onChange,
	  ...other
  }: FormLazySelectFieldProps<TFieldValues, Option, Key, DisableClearable>) => {
	const { field, fieldState } = useController({
		name,
		control,
		rules
	});

	const transformedField = {
		...field,
		onChange: (value: Key | null) => {
			field.onChange(value);
			onChange?.(value as ConditionalNullable<Key, DisableClearable>);
		},
		ref: undefined
	};

	return (
		<LazySelectField
			error={fieldState.error?.message}
			{...transformedField}
			{...other}
		/>
	);
};
